<template>
  <header
    class="flex h-12 items-center gap-3 bg-[--header-top-bg-color] text-sm text-[--header-top-text-color]"
    data-test-id="main-layout.top-header"
  >
    <div class="mx-auto w-full max-w-screen-2xl px-5 md:px-12">
      <div class="flex flex-row w-full justify-between">
        <LanguageSelector v-if="$context.availableLanguages && $context.availableLanguages.length > 1" />

        <CurrencySelector
          v-if="$context.availableCurrencies && $context.availableCurrencies.length > 1"
          class="h-full"
        />

        <!-- Innovadis custom: no ship-to selector -->
        <div class="ms-auto flex items-center">
          <!-- Call us block -->
          <div v-if="support_phone_number" class="flex items-center whitespace-nowrap">
            <VcIcon class="me-1.5 fill-primary" name="phone" size="sm" />

            <span class="mr-1 font-thin">
              {{ $t("shared.layout.header.top_header.call_us_label") }}
            </span>

            <a
              class="py-1 font-bold text-[--header-top-link-color] hover:text-[--header-top-link-hover-color]"
              data-test-id="support-phone-number-link"
              :href="`tel:${support_phone_number}`"
            >
              {{ support_phone_number }}
            </a>

            <span class="mx-4 h-5 w-px bg-primary" />
          </div>
        </div>

        <div>
          <TopHeaderLink
            v-if="isAuthenticated"
            :to="{ name: 'AccountBulkOrder' }"
            class="mr-3 font-normal last:mr-0"
            data-test-id="top-header.quick-order-link"
          >
            {{ $t("common.links.quick_order") }}
          </TopHeaderLink>
          <template v-for="(item, index) in topHeaderLinks" :key="index" v-if="topHeaderLinks">
            <TopHeaderLink :to="item.route ?? '#'" class="mr-3 font-normal last:mr-0">
              {{ item.title }}
            </TopHeaderLink>
          </template>
        </div>
      </div>
    </div>
  </header>
</template>

<script setup lang="ts">
import { shallowRef, onMounted } from "vue";
import { useModuleSettings } from "@/core/composables/useModuleSettings";
import { MODULE_XAPI_KEYS } from "@/core/constants/modules";
import { CurrencySelector, LanguageSelector } from "@/shared/layout/components";
import type { ExtendedMenuLinkType } from "@/core/types";
import { convertToExtendedMenuLink, Logger } from "@/core/utilities";
import type { MenuLinkType } from "@/core/api/graphql/types";
import { getMenu } from "@/core/api/graphql";
import TopHeaderLink from "../top-header-link.vue";
import { useUser } from "@/shared/account/composables/useUser";

const { getSettingValue } = useModuleSettings(MODULE_XAPI_KEYS.MODULE_ID);
const support_phone_number = getSettingValue(MODULE_XAPI_KEYS.SUPPORT_PHONE_NUMBER);
const topHeaderLinks = shallowRef<ExtendedMenuLinkType[]>([]);
const { isAuthenticated } = useUser();

async function fetchTopHeaderLinks() {
  try {
    topHeaderLinks.value = ((await getMenu("top-header-navigation")) as MenuLinkType[]).map((item) =>
      convertToExtendedMenuLink(item),
    );
  } catch (e) {
    Logger.error(`Error fetching top-header-navigation`, e);
  }
}

onMounted(fetchTopHeaderLinks);
</script>
